module.exports = __webpack_public_path__ + "img/headPortrait.0f1bbeb6.png";